import './phone-workspace.ajscss';

import { CobrowsingSessionState } from '@agent/core/store/cobrowsing';
import { CobrowsingFacade } from '@agent/core/store/cobrowsing/cobrowsing.facade';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { filter } from 'rxjs';

import { Logger } from '@contact/upgrade';

import templateUrl from './phone-workspace.template.html';

const MODULE_NAME = 'contactPhoneWorkspace';

enum WorkspaceTab {
  QUALIFICATION = 'QUALIFICATION',
  COBROWSING = 'COBROWSING',
}

class PhoneWorkspaceCtrl implements IComponentController {
  public name = MODULE_NAME;
  public responseId: string;
  public withCobrowsing = false;
  public readonly WorkspaceTab = WorkspaceTab;
  public isCobrowsingInProgress = false;
  public canDoCobrowsing = false;

  private activeWorkspaceTab = WorkspaceTab.QUALIFICATION;
  private availableWorkspaceTabs = new Set<WorkspaceTab>();
  private currentDomain: string;

  constructor(private readonly logger: Logger, private readonly cobrowsingFacade: CobrowsingFacade) {
    this.logger = logger.forSource(PhoneWorkspaceCtrl.name);

    this.availableWorkspaceTabs.add(WorkspaceTab.QUALIFICATION);
    if (this.withCobrowsing) this.logger.info(`Cobrowsing is enabled for domain [${this.currentDomain}]`);
  }

  $onInit(): void {
    this.cobrowsingFacade
      .getByBookingId(this.responseId)
      .pipe(
        ng1Destroy(this),
        filter(cobrowsingInfo => cobrowsingInfo?.bookingId === this.responseId)
      )
      .subscribe(cobrowsingInfo => {
        this.isCobrowsingInProgress = cobrowsingInfo?.sessionState === CobrowsingSessionState.active;
        this.canDoCobrowsing = cobrowsingInfo ? true : false;
        if (this.canDoCobrowsing) this.availableWorkspaceTabs.add(WorkspaceTab.COBROWSING);
      });
  }

  updateActiveTab(newWorkspace: WorkspaceTab) {
    this.activeWorkspaceTab = newWorkspace;
  }

  isQualificationWorkspaceSelected() {
    return this.activeWorkspaceTab === WorkspaceTab.QUALIFICATION;
  }

  isCobrowsingWorkspaceSelected() {
    return this.activeWorkspaceTab === WorkspaceTab.COBROWSING;
  }

  getResponseId() {
    return this.responseId;
  }
}

export class PhoneWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
    withCobrowsing: '<',
    callback: '&',
  };
  controller = ['logger', 'cobrowsingFacade', PhoneWorkspaceCtrl];
}

export default MODULE_NAME;
